module.exports = __webpack_public_path__ + "3fae4bbd3384c870a571bac0f3740333.svg";